// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__aVbbZ","placeholdersHeader":"styles_placeholdersHeader__1Wxsz","editorStyle":"styles_editorStyle__3PE8R","placeholdersBox":"styles_placeholdersBox__3oDV4"};